export default "__VITE_ASSET__23712061__"